<template>
  <div id="app">
    <pageHeader></pageHeader>
    <div class="content">
      <router-view/>
    </div>
    <pageFooter></pageFooter>

  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader.vue"
import pageFooter from "@/components/pageFooter.vue"

export default {
  name: 'App',
  components:{
    pageHeader,
    pageFooter
  }
}
</script>

<style>
#app{
  height: 100vh;
  display: flex;
  flex-direction: column;
}
body{ margin:0;padding:0; font-family:”宋体” ;overflow-y: hidden ;}
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /*overflow-x: hidden;*/
    /*overflow-y: hidden;*/
}
.content{
  overflow: auto;
}
a {
  text-decoration: none;
}
</style>
